var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960 211.2H489.818L364.16 82.024C356.928 74.6 347.008 70.4 336.64 70.4H64c-35.29 0-64 28.71-64 64v755.2c0 35.29 28.71 64 64 64h896c35.29 0 64-28.71 64-64V275.2c0-35.29-28.71-64-64-64zm-12.8 665.6H76.8V147.2h243.622L446.08 276.38c7.232 7.423 17.152 11.62 27.52 11.62h473.6v588.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.79234f79d858f466a5421b9d84a7054b.svg";
export { ForwardRef as ReactComponent };